import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  table: {
    '& th': {
      fontWeight: 600,
      backgroundColor: theme.palette.grey[100],
    },
  },
}));

const ValidationTable = ({ errors, warnings, valid }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(errors.length > 0 ? 0 : warnings.length > 0 ? 1 : 2);

  const renderErrorsTab = () => {
    if (errors.length === 0) {
      return (
        <div className="alert alert-success">
          <i className="fa fa-check-circle mr-2"></i>
          No errors found!
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className={`table table-bordered ${classes.table}`}>
          <thead>
            <tr>
              <th style={{ width: '80px' }}>Row</th>
              <th style={{ width: '150px' }}>Field</th>
              <th>Error Message</th>
              <th>Data Preview</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((error, idx) => (
              <React.Fragment key={idx}>
                {error.errors.map((err, errIdx) => (
                  <tr key={`${idx}-${errIdx}`}>
                    {errIdx === 0 && (
                      <td rowSpan={error.errors.length} className="font-weight-bold text-danger">
                        {error.row}
                      </td>
                    )}
                    <td>
                      <code>{err.field}</code>
                    </td>
                    <td className="text-danger">{err.message}</td>
                    {errIdx === 0 && (
                      <td rowSpan={error.errors.length}>
                        <small className="text-muted">
                          {JSON.stringify(error.data, null, 2).substring(0, 100)}...
                        </small>
                      </td>
                    )}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderWarningsTab = () => {
    if (warnings.length === 0) {
      return (
        <div className="alert alert-success">
          <i className="fa fa-check-circle mr-2"></i>
          No warnings!
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className={`table table-bordered ${classes.table}`}>
          <thead>
            <tr>
              <th style={{ width: '80px' }}>Row</th>
              <th>Warning</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {warnings.map((warning, idx) => (
              <tr key={idx}>
                <td className="font-weight-bold text-warning">{warning.row}</td>
                <td>{warning.message}</td>
                <td>
                  <small className="text-muted">{warning.details}</small>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderValidTab = () => {
    return (
      <div className="alert alert-success">
        <div className="alert-text">
          <i className="fa fa-check-circle mr-2"></i>
          <strong>{valid.length} records are valid and ready to process!</strong>
        </div>
      </div>
    );
  };

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab
          label={
            <span>
              Errors {errors.length > 0 && <span className="badge badge-danger ml-2">{errors.length}</span>}
            </span>
          }
        />
        <Tab
          label={
            <span>
              Warnings {warnings.length > 0 && <span className="badge badge-warning ml-2">{warnings.length}</span>}
            </span>
          }
        />
        <Tab
          label={
            <span>
              Valid <span className="badge badge-success ml-2">{valid.length}</span>
            </span>
          }
        />
      </Tabs>

      <Box mt={3}>
        {activeTab === 0 && renderErrorsTab()}
        {activeTab === 1 && renderWarningsTab()}
        {activeTab === 2 && renderValidTab()}
      </Box>
    </Box>
  );
};

export default ValidationTable;